import React from 'react';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';
import { EstimateShippingInfo } from '@domains/pdp-common';

import { ZigzinShippingTimer } from './ZigzinShippingTimer';

interface ZigzinArrivalDateTextProps {
  shippingInfo: EstimateShippingInfo;
  isEstimateTimestampExist: boolean;
  updateEstimateInfo: () => void;
}

export const ZigzinArrivalDateText: React.FC<React.PropsWithChildren<ZigzinArrivalDateTextProps>> = ({
  shippingInfo,
  isEstimateTimestampExist,
  updateEstimateInfo,
}) => {
  if (!shippingInfo) {
    return null;
  }
  const orderCutoffTimeText = shippingInfo.zigzin_shipping?.order_cutoff_time_text ?? '';
  const estimatedDateText = shippingInfo.zigzin_shipping?.estimated_date_text ?? '';

  if (isEstimateTimestampExist) {
    const splittedWithTimerZone = estimatedDateText.split('{order_cutoff_timestamp}') ?? [];

    const showTimer = (index: number) => {
      return splittedWithTimerZone.length !== index + 1;
    };
    const TagList = splittedWithTimerZone.map((content, idx) => (
      <React.Fragment key={idx}>
        {content && <span className={Typography.BODY_14_MEDIUM} dangerouslySetInnerHTML={{ __html: content }} />}
        {showTimer(idx) && (
          <ZigzinShippingTimer
            className={`${Typography.BODY_14_MEDIUM} estimated-time`}
            estimate_timestamp={shippingInfo.zigzin_shipping?.order_cutoff_timestamp ?? 0}
            updateEstimateInfo={updateEstimateInfo}
          />
        )}
      </React.Fragment>
    ));

    return <div>{TagList}</div>;
  }
  return (
    <div>
      <DateText
        className={Typography.BODY_14_MEDIUM}
        dangerouslySetInnerHTML={{
          __html: `${orderCutoffTimeText} ${estimatedDateText}`,
        }}
      />
    </div>
  );
};

const DateText = styled.span`
  color: ${vars.color.textTertiary};
`;
